import { Route, Routes } from "react-router-dom";
import { CatalogLadleProvider } from "./context/CatalogLadleContext";
import { CatalogLadlePage } from "./pages/CatalogLadlePage";

type Props = {};
const CatalogLadle = (props: Props) => {
  return (
    <CatalogLadleProvider>
      <Routes>
        <Route index element={<CatalogLadlePage />}></Route>
        <Route path=":ladleId" element={<CatalogLadlePage />}></Route>
      </Routes>
    </CatalogLadleProvider>
  );
};
export default CatalogLadle;
